import { AxiosResponse } from 'axios';

/**
 * Generates a
 * @param scope A valid scope. example 'redux', 'redux-saga',
 * 'boot-application'...
 *
 * @example
 * ```typescript
 *   const errorhandling = Promise
 *     .reject(42)
 *     .catch(createScopedErrorHandler('api'));
 * ```
 *
 */
export const createScopedErrorHandler = (scope: string) => {
  return function handleError(...args: any) {
    if (args[0] && args[0]?.response && args[0].response.status) {
      const { status, data } = args[0].response as AxiosResponse<any>;

      console.error(
        `[${scope}][status:${status}]`,
        data,
        args[0].message,
        ...args.slice(1),
      );
    } else {
      console.error(`[${scope}]`, ...args);
    }
  };
};
